import { render } from "./index.vue?vue&type=template&id=a6205946&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a6205946&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a6205946"

export default script